import { hash, normalizePhone } from '@/core/utils/string';
import { GetUserResponseSchema, UserSchema } from './user.schema';

export function createUser() {
	return GetUserResponseSchema.transform(async (event) => {
		const phone = event.phone ? normalizePhone(event.phone) : null;

		return {
			advertiserId: event.advertiser_id ?? null,
			cdpId: event.mparticle_id ?? null,
			email: event.email ?? null,
			hashedEmail: event.email ? await hash(event.email) : null,
			hashedPhone: phone ? await hash(phone) : null,
			id: event.id,
			phone,
		};
	}).pipe(UserSchema);
}
